// Copyright ©️ 2026 eVolve MEP, LLC

import { createModalRegistry } from 'components/Mantine/Modals/createModalRegistry';

import { AssignTasksPickerModal } from './AssignTasksPickerModal';
import { CreateEditWorkCellModal } from './CreateEditWorkCellModal';
import { DeleteWorkCellModal } from './DeleteWorkCellModal';
import { DiscardDraftChangesModal } from './DiscardDraftChangesModal';
import { SaveDraftChangesModal } from './SaveDraftChangesModal';
import { UnassignTaskTypeModal } from './UnassignTaskTypeModal';

export const [WorkCellSetupModalProvider, useWorkCellSetupModals] = createModalRegistry({
  assignTasksPickerModal: AssignTasksPickerModal,
  createEditWorkCellModal: CreateEditWorkCellModal,
  deleteWorkCellModal: DeleteWorkCellModal,
  discardDraftChangesModal: DiscardDraftChangesModal,
  saveDraftChangesModal: SaveDraftChangesModal,
  unassignTaskTypeModal: UnassignTaskTypeModal,
});
